import { Authenticated } from '@refinedev/core';
import { ErrorComponent } from '@refinedev/mui';
import { Route, Routes as RouterRoutes, Outlet } from 'react-router-dom';
import { NavigateToResource, CatchAllNavigate } from '@refinedev/react-router';

import { UsersList, UserShow } from '@/features/researchers';
import { StudyEdit, StudyList, StudyShow } from '@/features/studies';
import { Header } from '@/shared/components/layout';
import { Login } from '@/core/auth/components/Login';
import { AuthenticatedLayout } from '@/shared/components/layout';
import { QuestionnairePage } from '@/features/questionnaires/pages';
import { EditSchedulingPage } from '@/features/scheduling';
import { AuditLogsList } from '@/features/audit-logs';
import { ResearcherCreate } from '@/features/researchers/pages/Create';
import { ResearcherEdit } from '@/features/researchers/pages/Edit';
import {
  ParticipantsList,
  ParticipantShow,
  ParticipantEdit,
} from '@/features/participants';

export const Routes = () => {
  return (
    <RouterRoutes>
      <Route
        element={
          <Authenticated
            key="authenticated-inner"
            fallback={<CatchAllNavigate to="/login" />}
          >
            <AuthenticatedLayout Header={Header} />
          </Authenticated>
        }
      >
        <Route
          index
          element={<NavigateToResource resource="admin/studies" />}
        />
        <Route path="/researchers">
          <Route index element={<UsersList />} />
          <Route path="create" element={<ResearcherCreate />} />
          <Route path="edit/:id" element={<ResearcherEdit />} />
          <Route path="show/:id" element={<UserShow />} />
        </Route>
        <Route path="/participants">
          <Route index element={<ParticipantsList />} />
          <Route path="edit/:id" element={<ParticipantEdit />} />
          <Route path="show/:id" element={<ParticipantShow />} />
        </Route>
        <Route path="/studies">
          <Route index element={<StudyList />} />
          <Route path="edit/:id" element={<StudyEdit />} />
          <Route path="show/:id" element={<StudyShow />} />
          <Route
            path=":id/initial-questionnaire/create"
            element={<QuestionnairePage kind="INITIAL" />}
          />
          <Route
            path=":id/initial-questionnaire/edit/:questionnaireId"
            element={<QuestionnairePage kind="INITIAL" />}
          />
          <Route
            path=":id/ema-questionnaire/create"
            element={<QuestionnairePage kind="EMA" />}
          />
          <Route
            path=":id/ema-questionnaire/edit/:questionnaireId"
            element={<QuestionnairePage kind="EMA" />}
          />
        </Route>
        <Route path="/questionnaire-scheduling">
          <Route
            path=":questionnaireId/edit"
            element={<EditSchedulingPage />}
          />
        </Route>
        <Route path="/audit-logs">
          <Route index element={<AuditLogsList />} />
        </Route>
        <Route path="*" element={<ErrorComponent />} />
      </Route>
      <Route
        element={
          <Authenticated key="authenticated-outer" fallback={<Outlet />}>
            <NavigateToResource />
          </Authenticated>
        }
      >
        <Route path="/login" element={<Login />} />
      </Route>
    </RouterRoutes>
  );
};
